import { COOKIE_CONFIG } from './constants';

/**
 * Set a cookie with the given name, value, and options
 */
export function setCookie(name: string, value: string, days?: number): void {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  const sameSite = '; samesite=strict';
  
  document.cookie = `${name}=${value || ''}${expires}${secure}${sameSite}; path=/`;
}

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | null {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  
  return null;
}

/**
 * Delete a cookie by name
 */
export function deleteCookie(name: string): void {
  setCookie(name, '', -1);
}

/**
 * Set authentication cookies
 * NOTE: This function is deprecated - cookies are now set by the backend as HttpOnly cookies.
 * Client-side cookie setting is not secure and is no longer used.
 */
export function setAuthCookies(accessToken: string, refreshToken: string, staySignedIn: boolean): void {
  // Cookies are now set by the backend as HttpOnly cookies for security
  // This function is kept for backward compatibility but does nothing
  console.warn('setAuthCookies is deprecated - cookies are set by backend as HttpOnly cookies');
}

/**
 * Get authentication cookies
 * Note: HttpOnly cookies cannot be read by JavaScript for security.
 * This function checks if cookies exist (but cannot read their values).
 * The actual token values are sent automatically with requests via credentials: true.
 */
export function getAuthCookies(): { accessToken: string | null; refreshToken: string | null } {
  // HttpOnly cookies cannot be read by JavaScript, so we return null
  // The presence of cookies is checked by making authenticated API calls
  // Tokens are automatically sent with requests when credentials: true is set
  return {
    accessToken: null, // Cannot read HttpOnly cookie value
    refreshToken: null // Cannot read HttpOnly cookie value
  };
}

/**
 * Clear authentication cookies
 * Note: HttpOnly cookies cannot be deleted by JavaScript - they must be cleared by the backend
 * This function clears any non-HttpOnly cookies for cleanup
 */
export function clearAuthCookies(): void {
  // Clear admin cookies (may be HttpOnly, but try anyway for cleanup)
  deleteCookie(COOKIE_CONFIG.ACCESS_TOKEN_COOKIE);
  deleteCookie(COOKIE_CONFIG.REFRESH_TOKEN_COOKIE);
  // Also try to clear admin-specific cookie names
  deleteCookie('adminAccessToken');
  deleteCookie('adminRefreshToken');
} 